import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiUser, FiClock, FiArrowRight, FiBell, FiCalendar } = FiIcons;

const WorkshopCard = ({ workshop, onJoin, onRemind }) => {
  return (
    <motion.div 
      layout
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-[40px] overflow-hidden border border-brand-dark group hover:border-accent-gold transition-all duration-500 hover:shadow-2xl flex flex-col h-full"
    >
      <div className="h-48 md:h-56 relative overflow-hidden">
        <img 
          src={workshop.image} 
          alt={workshop.title} 
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-6 left-6">
          <span className="bg-white/20 backdrop-blur-md border border-white/20 px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest text-white">
            {workshop.category}
          </span>
        </div>
        <div className="absolute bottom-4 left-6 flex items-center gap-2 text-white text-[10px] font-bold">
          <SafeIcon icon={FiCalendar} className="text-accent-gold" />
          {new Date(workshop.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
        </div>
      </div>

      <div className="p-8 flex-grow flex flex-col">
        <h3 className="text-xl md:text-2xl font-serif text-accent-navy group-hover:text-accent-gold transition-colors leading-tight mb-4">
          {workshop.title}
        </h3>
        <p className="text-sm text-text-muted font-light leading-relaxed mb-8 line-clamp-2">
          {workshop.description}
        </p>

        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-brand-light flex items-center justify-center text-accent-gold">
              <SafeIcon icon={FiUser} className="w-4 h-4" />
            </div>
            <div>
              <p className="text-[8px] font-black uppercase text-text-muted tracking-tighter">Facilitator</p>
              <p className="text-[10px] font-bold text-accent-navy">{workshop.facilitator}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-brand-light flex items-center justify-center text-accent-gold">
              <SafeIcon icon={FiClock} className="w-4 h-4" />
            </div>
            <div>
              <p className="text-[8px] font-black uppercase text-text-muted tracking-tighter">Duration</p>
              <p className="text-[10px] font-bold text-accent-navy">{workshop.duration}</p>
            </div>
          </div>
        </div>

        <div className="mt-auto pt-6 border-t border-brand-light flex flex-col sm:flex-row gap-3">
          <button 
            onClick={() => onJoin(workshop)}
            className="flex-grow btn-primary py-3 px-6 text-[10px] font-black uppercase tracking-[0.15em] flex items-center justify-center gap-2 group/btn"
          >
            Join Session <SafeIcon icon={FiArrowRight} className="group-hover/btn:translate-x-1 transition-transform" />
          </button>
          <button 
            onClick={() => onRemind(workshop)}
            className="p-3 bg-brand-light text-accent-navy rounded-2xl hover:bg-accent-gold hover:text-white transition-all border border-brand-dark flex items-center justify-center gap-2 sm:w-auto"
            title="Set Reminder"
          >
            <SafeIcon icon={FiBell} className="w-4 h-4" />
            <span className="sm:hidden text-[10px] font-black uppercase tracking-widest">Remind Me</span>
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default WorkshopCard;